import React from 'react';
import PropTypes from 'prop-types';
import './BatchSelector.css';

/**
 * Component for selecting implementation batches
 * @param {Object} props - Component props
 * @param {Array} props.batches - List of available batches
 * @param {string} props.currentBatch - Current batch ID
 * @param {Function} props.onBatchChange - Handler for batch change
 */
function BatchSelector({ batches, currentBatch, onBatchChange }) {
  // Sort batches by priority
  const sortedBatches = [...batches].sort((a, b) => a.priority - b.priority);
  
  // Get progress stats
  const completedBatches = batches.filter(b => b.status === 'completed').length;
  const totalBatches = batches.length;
  const progressPercentage = totalBatches === 0 ? 0 : (completedBatches / totalBatches) * 100;
  
  return (
    <div className="batch-selector">
      <div className="batch-header">
        <div className="batch-progress">
          <div className="progress-text">
            {completedBatches} of {totalBatches} batches completed
          </div>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${progressPercentage}%` }}
            ></div>
          </div>
        </div>
      </div>
      
      <div className="batch-list">
        {sortedBatches.length > 0 ? (
          sortedBatches.map(batch => {
            const isActive = batch.id === currentBatch;
            const isCompleted = batch.status === 'completed';
            
            return (
              <div 
                key={batch.id}
                className={`batch-item ${isActive ? 'active' : ''} ${isCompleted ? 'completed' : ''}`}
                onClick={() => onBatchChange(batch.id)}
              >
                <div className="batch-status">
                  {isCompleted ? (
                    <span className="status-icon completed">✓</span>
                  ) : (
                    <span className="status-icon pending">⌛</span>
                  )}
                </div>
                <div className="batch-details">
                  <div className="batch-name">
                    {batch.name}
                  </div>
                  <div className="batch-info">
                    <span className="batch-files">{batch.files.length} files</span>
                    <span className="batch-loc">{batch.totalLoc} LOC</span>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <div className="no-batches">
            No implementation batches defined yet.
          </div>
        )}
      </div>
    </div>
  );
}

BatchSelector.propTypes = {
  batches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      files: PropTypes.array.isRequired,
      status: PropTypes.string.isRequired,
      priority: PropTypes.number.isRequired,
      totalLoc: PropTypes.number
    })
  ).isRequired,
  currentBatch: PropTypes.string,
  onBatchChange: PropTypes.func.isRequired
};

export default BatchSelector;
